import { adminManagementApi } from "@/lib/api"
import { useQuery, useMutation } from "@tanstack/react-query"
import { queryClient } from "@/lib/queryClient"
import { AdminDTO, AdminCreateRequest } from "@/gen/api"

type Admin = AdminDTO

const adminListApi = async (): Promise<AdminDTO[]> => {
  const response = await adminManagementApi.getAdmins()
  return response.data.data ?? []
}

export const useGetAdminList = (enabled = true) => {
  return useQuery<Admin[]>({
    queryKey: ["admins"],
    queryFn: adminListApi,
    enabled,
  })
}

const createAdminApi = async (adminData: AdminCreateRequest) => {
  return await adminManagementApi.createAdmin(adminData)
}

export const useCreateAdmin = () => {
  return useMutation({
    mutationFn: createAdminApi,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admins"] })
    },
  })
}

const deleteAdminApi = async (adminId: string) => {
  return await adminManagementApi.deleteAdmin(adminId)
}

export const useDeleteAdmin = () => {
  return useMutation({
    mutationFn: deleteAdminApi,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admins"] })
    },
  })
}
